<ng-container *ngFor="let item of items; let i = index">
  <a *ngIf="item.link; else plainWord"
    class="word-ticker-item hover:underline"
    [routerLink]="item.link.path" [queryParams]="item.link.queryParams" [title]="item.link.title ?? ''"
    [class.active]="i === index"
    [attr.aria-hidden]="i !== index || null"
    [attr.tabindex]="i === index ? null : -1">{{ item.text }}&ngsp;</a>
  <ng-template #plainWord>
    <span class="word-ticker-item"
      [class.active]="i === index"
      [attr.aria-hidden]="i !== index || null">{{ item.text }}&ngsp;</span>
  </ng-template>
</ng-container>
